export interface IFaxInbox {
    Date: string,
    ReceiverNumber: string,
    SenderNumber: string,
    ErrorMessage: string | null,
    FaxStatus: number,
    FaxStatusDesc: string,
    Id: string,
    Subject: string,
    PersianDate: string,
    InternalReceiverNumber: string,
    NumberOfPages: number

}

export interface IFaxOutbox {
    id: string,
    senderNumber: string,
    receiverNumber: string,
    title: string,
    date: string,
    faxStatus: string,
    errorMessage: string,
    url: string,
    customerLineId: string,
    internalReceiverNumber: string,
    waitTimeInSecond: number,
    parentFaxOutboxId: string,
    tryCount: number

}

export interface SendFaxResponse {
    status: string,
    errorMessage: string
}

export interface FaxState {
    customerFaxNumbers: [],
    getResendFaxPending: boolean,
    customerHasIvrProduct: boolean,
    getCustomerHasIvrProductPending: boolean,
    sendFaxSuccess: SendFaxResponse | null,
    sendFaxPending: boolean,
    deleteInboxItemSuccess: boolean,
    deleteInboxItemPending: boolean,
    downloadFaxOutboxFilePending: boolean,
    downloadFaxOutboxFileResult: any,
    downloadFaxOutboxFileSuccess: boolean,
    downloadFaxInboxFileSuccess: boolean,
    downloadFaxInboxFileResult: any,
    downloadFaxInboxFilePending: boolean,
    getResendFaxSuccess: SendFaxResponse | null,
    sendFaxError: any,
    customerActiveFaxNumbers: any[]
}


export class FaxInbox implements IFaxInbox {
    ErrorMessage = "";// string | null;
    senderNumber = "";
    Date = "";
    ReceiverNumber = "";
    FaxStatus = 0;
    FaxStatusDesc = "";
    Id = "";
    Subject = "";
    PersianDate = "";
    InternalReceiverNumber = "";
    SenderNumber = "";
    NumberOfPages = 0;
    data: IFaxInbox[] = []
    isLastPage = false;
    pageNumber = 1;
    pageSize = 10;
    totalCount = null


    constructor(aliResponse: any | null) {
        if (aliResponse) {
            this.pageNumber = aliResponse.pageNumber
            this.pageSize = aliResponse.pageSize
            this.totalCount = aliResponse.totalCount
            this.mapInboxList(aliResponse.data)

        }
    }


    mapInboxList(faxList: any) {
        this.data = [];
        faxList.forEach((item: any) => {
            let temp: IFaxInbox = {
                ReceiverNumber: item.receiverNumber,
                FaxStatus: item.faxStatus,
                FaxStatusDesc: item.faxStatusDesc,
                Id: item.id,
                Subject: item.subject,
                PersianDate: item.persianDate,
                InternalReceiverNumber: item.internalReceiverNumber,
                SenderNumber: item.senderNumber,
                Date: item.date,
                ErrorMessage: item.errorMessage,
                NumberOfPages: item.numberOfPages
            }
            this.data.push(temp);
        })
    }


}


export class FaxOutbox implements IFaxOutbox {

    id = "";
    receiverNumber = "";
    senderNumber = "";
    title = "";
    date = "";
    faxStatus = "";
    errorMessage = "";
    url = "";
    customerLineId = "";
    internalReceiverNumber = "";
    waitTimeInSecond = 0;
    parentFaxOutboxId = "";
    tryCount = 0;
    data: IFaxOutbox[] = []
    pageNumber = 1;
    pageSize = 10;
    totalCount = null


    constructor(response: any | null) {
        if (response) {
            this.pageNumber = response.pageNumber
            this.pageSize = response.pageSize
            this.totalCount = response.totalCount
            this.mapOutboxList(response.data)
        }
    }


    mapOutboxList(faxList: any) {
        this.data = [];
        faxList.forEach((item: any) => {
            let temp: IFaxOutbox = {
                receiverNumber: item.receiverNumber,
                faxStatus: item.faxStatus,
                id: item.id,
                title: item.title,
                internalReceiverNumber: item.internalReceiverNumber,
                senderNumber: item.senderNumber,
                date: item.date,
                errorMessage: item.errorMessage,
                waitTimeInSecond: item.waitTimeInSecond,
                parentFaxOutboxId: item.parentFaxOutboxId,
                url: item.url,
                customerLineId: item.customerLineId,
                tryCount: item.tryCount
            }
            this.data.push(temp);
        })
    }


}